"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.empty = void 0;
var _ApolloLink = require("apollo-stack-hubspot/@apollo/client/link/core/ApolloLink");
var empty = exports.empty = _ApolloLink.ApolloLink.empty;